import React, { useState } from 'react';

const TestimonialSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const testimonial = {
    text: "Working with Timo and the AyanshTech Solutions team was one of the best decisions we made for our business. From the very beginning, Timo explained everything clearly and guided us through the entire process with professionalism and patience. He was always available to answer our questions and ensured the migration was smooth and hassle-free.The results exceeded our expectations. Our monthly infrastructure costs were reduced from $1,300 to just $250, while maintaining outstanding performance, reliability, and uptime. This optimization has had a significant positive impact on our business, and we highly recommend AyanshTech Solutions to anyone looking to improve their cloud infrastructure and reduce costs.",
    author: {
      name: "Tamika Williams",
      title: "CEO, Aquarion Asset Management, USA",
      avatar: "../assets/images/migration/aleksandr-shuliko-lg-3ea0a954162973cd0cc62f13b47bc170.png",
      companyLogo: "../assets/images/migration/BANDIT2tkk.png"
    },
    tags: ["Cloud Migration", "AWS Exit", "Proxmox", "81% Cost Reduction"]
  };

  // Modal Component
  const TestimonialModal = () => {
    if (!isModalOpen) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center  bg-black/40 backdrop-blur-sm">
        <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8 relative animate-[fadeInUp_0.2s_ease-out]">
          <button 
            onClick={() => setIsModalOpen(false)}
            className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          <div className="pr-8">
            <div className="flex flex-wrap items-center gap-1.5 mb-5">
              {testimonial.tags.map((tag, index) => (
                <span 
                  key={index}
                  className={`inline-flex items-center rounded-full ${index === 0 ? 'bg-brand-primary/10 text-brand-primary' : 'border border-gray-200 bg-gray-50 text-gray-600'} px-2.5 py-1 text-xs font-semibold ${index !== 0 ? 'text-[11px] font-medium' : 'text-xs'}`}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
          
          <blockquote className="text-gray-700 text-base leading-relaxed italic mb-6 whitespace-pre-line">
            “{testimonial.text}”
          </blockquote>
          
          <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <img 
                src={testimonial.author.avatar} 
                alt={testimonial.author.name} 
                className="w-full h-full object-cover" 
              />
            </div>
            <div className="flex-1">
              <p className="font-bold text-gray-900">{testimonial.author.name}</p>
              <p className="text-sm text-gray-500">{testimonial.author.title}</p>
            </div>
            <div className="flex-shrink-0 h-8 max-w-[100px]">
              <img 
                src={testimonial.author.companyLogo} 
                alt="EVA Real Estate" 
                className="h-full w-auto object-contain opacity-70" 
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <section className="py-8 md:py-5  overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-4">
          
          {/* Header Section */}
          <div className="text-center mb-8 md:mb-10 transition-all duration-700 opacity-100 translate-y-0">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Technology Solutions with Real Business Value
            </h2>
            <div className="h-1 w-16 bg-green-600 mx-auto transition-opacity duration-700 ease-out opacity-100"></div>
            <p className="text-base text-gray-600 max-w-3xl mx-auto mt-4 leading-relaxed">
              Infrastructure modernization, cloud services, and managed operations focused on practical outcomes, improved efficiency, and long-term reliability.
            </p>
          </div>
          
          {/* Testimonial Card */}
          <div className="grid grid-cols-1 max-w-4xl mx-auto gap-5 mb-8 transition-all duration-700 delay-300 opacity-100 translate-y-0">
            
            <button 
              type="button" 
              onClick={() => setIsModalOpen(true)}
              className="bg-white rounded-2xl p-5 md:p-6 text-left cursor-pointer w-full h-full border-2 border-brand-primary/40 shadow-xl ring-1 ring-brand-primary/10 transition-all duration-200 hover:shadow-2xl hover:-translate-y-1 flex flex-col min-h-[280px]"
            >
              {/* Tags and Quote Icon */}
              <div className="flex items-start justify-between gap-4">
                <div className="flex flex-wrap items-center gap-1.5 mb-4">
                  {testimonial.tags.map((tag, index) => (
                    <span 
                      key={index}
                      className={`inline-flex items-center rounded-full ${index === 0 ? 'bg-brand-primary/10 text-green-600 border border-gray-200 bg-gray-50' : 'border border-gray-200 bg-gray-50 text-gray-600'} px-2.5 py-1 text-xs font-semibold ${index !== 0 ? 'text-[11px] font-medium' : 'text-xs'}`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <svg className="w-9 h-9 text-brand-primary/20 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"></path>
                </svg>
              </div>
              
              {/* Testimonial Text */}
              <div className="flex-1 flex items-center my-2 min-h-0">
                <p className="text-gray-700 text-sm md:text-[15px] leading-relaxed italic whitespace-pre-line line-clamp-[6]">
                  "{testimonial.text}"
                </p>
              </div>
              
              {/* Author Info */}
              <div className="pt-4 border-t border-gray-100 flex items-center justify-between gap-4">
                
                {/* Avatar and Name */}
                <div className="flex items-center gap-3 min-w-0 flex-1">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-brand-primary/20 bg-gray-100">
                    <img 
                      src={testimonial.author.avatar} 
                      alt={testimonial.author.name} 
                      className="w-full h-full object-cover" 
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="font-bold text-gray-900 text-base md:text-lg truncate">
                      {testimonial.author.name}
                    </p>
                    <p className="text-xs md:text-sm text-gray-500 truncate">
                      {testimonial.author.title}
                    </p>
                  </div>
                </div>
                
                {/* Company Logo */}
                <div className="flex-shrink-0 h-7 md:h-8 max-w-[105px]">
                  <img 
                    src={testimonial.author.companyLogo} 
                    alt="EVA Real Estate" 
                    className="h-full w-auto object-contain opacity-70" 
                    loading="lazy"
                  />
                </div>
                
              </div>
              
            </button>
            
          </div>
          
        </div>
      </section>

      {/* Modal */}
      <TestimonialModal />
    </>
  );
};

export default TestimonialSection;